<ng-content *ngIf="!isProcessing && !showEmptyResultMsg"></ng-content>

<div
  *ngIf="isProcessing || showEmptyResultMsg"
  class="flex flex-col items-center justify-center text-lg"
  [ngClass]="cssClasses || ['h-[42vh]']"
  [ngStyle]="cssStyles"
>
  <div
    *ngIf="isProcessing; else notProcessing"
    class="flex flex-col items-center justify-center"
  >
    <h3 *ngIf="processingMsg" class="pt-10 pb-6 m-0 text-base animate-pulse">
      {{ processingMsg }}
    </h3>

    <mat-spinner
      [diameter]="spinnerDiameter"
      [defaultColor]="primary"
      [strokeWidth]="5"
    ></mat-spinner>

    <h4
      *ngIf="secondaryProcessingMsg"
      class="mt-8 text-xs italic animate-pulse"
    >
      {{ secondaryProcessingMsg }}
    </h4>
  </div>

  <ng-template #notProcessing>
    <div
      *ngIf="showEmptyResultMsg"
      class="flex flex-col items-center justify-center pt-10 pb-6 m-0 text-base"
    >
      <span>{{ emptyResultMsg }}</span>
      <span class="text-sm italic"
        >(If you think this is an issue, please contact an administrator.)</span
      >
    </div>
  </ng-template>
</div>
